import React from 'react';

function GaugeChart({ value = 0, max = 100, label = '' }) {
  const numValue = parseFloat(value);
  const numMax = parseFloat(max);
  const safeMax = !isNaN(numMax) && numMax > 0 ? numMax : 100;
  const pct =
    !isNaN(numValue) && safeMax > 0
      ? Math.max(0, Math.min(numValue / safeMax, 1))
      : 0;

  const radius = 44;
  const circumference = 2 * Math.PI * radius;
  const visibleArc = (270 / 360) * circumference;
  const dashArray = `${visibleArc} ${circumference}`;
  const dashOffset = visibleArc * (1 - pct);

  const hue = 120 - pct * 120;
  const color = `hsl(${hue}, 85%, 60%)`;
  const percentage = Math.round(pct * 100);

  return (
    <div className="flex w-full flex-col items-center gap-4">
      <div className="w-full text-center text-xs font-semibold uppercase tracking-[0.2em] text-white/40">
        {label}
      </div>
      <div className="relative flex h-32 w-32 items-center justify-center">
        <svg viewBox="0 0 120 120" className="h-full w-full">
          <g transform="translate(60,60)">
            <circle
              r={radius}
              fill="none"
              stroke="rgba(255,255,255,0.08)"
              strokeWidth="12"
              strokeDasharray={dashArray}
              strokeLinecap="round"
              transform="rotate(135)"
            />
            <circle
              r={radius}
              fill="none"
              stroke={color}
              strokeWidth="12"
              strokeDasharray={dashArray}
              strokeDashoffset={dashOffset}
              strokeLinecap="round"
              transform="rotate(135)"
              style={{ filter: 'drop-shadow(0 0 12px rgba(255,255,255,0.15))' }}
            />
          </g>
        </svg>
        <div className="absolute inset-[24%] rounded-full border border-white/10 bg-[#0f1219]/90 shadow-inner shadow-black/40" />
        <div className="absolute inset-[32%] flex flex-col items-center justify-center rounded-full bg-gradient-to-br from-white/5 to-transparent text-white">
          <span className="text-2xl font-semibold">
            {isNaN(numValue) ? '0.00' : numValue.toFixed(2)}
          </span>
          <span className="text-[10px] font-medium uppercase tracking-widest text-white/50">
            mm/s
          </span>
        </div>
        <div className="absolute bottom-2 flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-1 text-[11px] font-medium text-white">
          <span className="inline-flex h-2 w-2 rounded-full" style={{ backgroundColor: color }} />
          {percentage}% of {safeMax}
        </div>
      </div>
    </div>
  );
}

export default GaugeChart;
